import { render, staticRenderFns } from "./SaleBookingHistoryTable.vue?vue&type=template&id=6b044685&scoped=true"
import script from "./SaleBookingHistoryTable.vue?vue&type=script&lang=js"
export * from "./SaleBookingHistoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b044685",
  null
  
)

export default component.exports